import { JsonRpc } from 'eosjs'

const rpc = new JsonRpc('https://eos.greymass.com', {fetch})

export default {
  async getCurrencyBalance ({tokenAccount, symbol, account}) {
    return rpc.get_currency_balance(tokenAccount, account, symbol)
  },
  async fetchAccountHistory ({account, pos}) {
    return rpc.history_get_actions(account, pos)
  }
}



// WEBPACK FOOTER //
// ./src/api/eosrpc.js